import { createStyles } from "antd-style";

export const useModalHardwareInstallStyles = createStyles(({ css }: any) => ({
  drawer: css`
    position: relative;
  `,
  loader: css`
    position: absolute;
    inset: 0;
    margin: auto;
  `,
  description: css`
    text-align: center;
  `,
}));
